module.exports = __webpack_public_path__ + "img/avatar-a.fac33bda.svg";